import { cva, type VariantProps } from 'noddi-ui-common';
import { useState } from 'react';

const frameVariants = cva(
  'flex shrink-0 items-center justify-center overflow-hidden rounded-md border border-border bg-background',
  {
    variants: {
      size: {
        small: 'size-4',
        medium: 'size-6'
      }
    },
    defaultVariants: { size: 'medium' }
  }
);

type Props = {
  url: string;
  alt?: string;
} & VariantProps<typeof frameVariants>;

export const MembershipProgramLogo = ({ url, alt = '', size }: Props) => {
  const [failed, setFailed] = useState(false);
  if (!url || failed) {
    return null;
  }

  return (
    <span className={frameVariants({ size })}>
      <img src={url} alt={alt} className='size-full object-contain p-0.5' onError={() => setFailed(true)} />
    </span>
  );
};
